<template>
  <div
    id="customer-flyout"
    :class="{'d-block':show_customer_details,'d-none':!show_customer_details}"
  >
    <div class="heading">
      <b-row class="px-3" style="padding-top:16px;padding-bottom:16px;">
        <b-col class="w-100">
          <h5 class="mb-0 text-left">
            Customer Details
            <span class="float-right pr-2">
              <i class="la la-close cursor_pointer" @click="toggleCustomerDetails()"></i>
            </span>
          </h5>
        </b-col>
      </b-row>
    </div>

    <div class="header border-top border-bottom" style="background:#f7f7f7 !important">
      <b-row class="py-4 px-3">
        <div class="w-100 px-4">
          <div class="d-flex w-100">
            <div class="w-75">
              <h5 class="text-truncate">{{CustomerDetails.main_detail.cus_display_name}}</h5>
            </div>
            <div class="w-25">
              <a target="_blank" :href="'/app/customer/view/'+CustomerDetails.main_detail.cus_id">
                <small class="float-right pr-3 btn-link text-primary cursor_pointer">View</small>
              </a>
            </div>
          </div>
          <div class="w-100 text-truncate">
            <small class="text-muted" v-if="CustomerDetails.main_detail.cus_type == 2">
              <i class="la la-building-o la-lg pr-2"></i>
              {{ CustomerDetails.main_detail.cus_comp_name }}
            </small>
          </div>
          <small class="text-muted">
            <i class="la la-phone la-lg pr-2"></i>
            {{ CustomerDetails.main_detail.cus_ph_no_1}}
          </small>
          <div class="w-100 text-truncate">
            <small class="text-muted" v-if="CustomerDetails.main_detail.cus_mail">
              <i class="la la-envelope la-lg pr-2"></i>
              {{ CustomerDetails.main_detail.cus_mail}}
            </small>
          </div>
        </div>
      </b-row>
    </div>
    <b-row class="pl-3 pr-3 mt-3">
      <b-col class="pr-1">
        <h5>
          <small class="text-primary fw-semi-bold">Unused Credits</small>
        </h5>
        <h5 class>
          {{
          getDetails(
          $AppDetails.currency_details,
          CustomerDetails.main_detail.cus_currency,
          "currency_symbol"
          )
          }} {{ CustomerDetails.unused_credits == '' ? '0.00' : parseFloat(CustomerDetails.unused_credits.total_unused_credits).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
        </h5>
      </b-col>
      <b-col class="pl-1">
        <h5>
          <small class="text-warning fw-semi-bold">Outstanding Receivables</small>
        </h5>
        <h5>
          {{
          getDetails(
          $AppDetails.currency_details,
          CustomerDetails.main_detail.cus_currency,
          "currency_symbol"
          )
          }} {{ CustomerDetails.unused_credits == '' ? '0.00' : parseFloat(CustomerDetails.unused_credits.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
        </h5>
      </b-col>
    </b-row>
    <hr class="mb-0" />
    <b-row class="px-3 mt-3">
      <b-col>
        <!-- Billing Address -->
        <p v-b-toggle.bill-addr class="mb-0 mb-3 cursor_pointer">
          <i class="fa fa-angle-down fw-semi-bold float-right"></i>Billing Address
        </p>
        <b-collapse id="bill-addr" class="pr-3" visible>
          <div class="media">
            <div class="media-left">
              <i class="icon-lg icon-fw la la-map-marker la-lg mr-2"></i>
            </div>
            <div class="media-body">
              <address class="mar-no text-muted text-muted">
                {{ CustomerDetails.customer_addr[0].cus_addr_line_1 }} {{ CustomerDetails.customer_addr[0].cus_addr_line_2 }}
                {{ CustomerDetails.customer_addr[0].cus_city }} {{ getDetails($AppDetails.state_details,CustomerDetails.customer_addr[0].cus_state,'state_name') }}
                {{ getDetails($AppDetails.country_details,CustomerDetails.customer_addr[0].cus_country,'country_name') }} {{ CustomerDetails.customer_addr[0].cus_pincode }}
              </address>
            </div>
          </div>
        </b-collapse>
      </b-col>
    </b-row>
    <b-row class="px-3 mt-3">
      <b-col>
        <!-- Shipping Address -->
        <p v-b-toggle.ship-addr class="mb-0 mb-3 cursor_pointer">
          <i class="fa fa-angle-down font-weight-bold float-right"></i>Shipping Address
        </p>
        <b-collapse id="ship-addr" class="pr-3" visible>
          <div class="media">
            <div class="media-left">
              <i class="icon-lg icon-fw la la-map-marker la-lg mr-2"></i>
            </div>
            <div class="media-body">
              <address class="mar-no text-muted text-truncate">
                {{ CustomerDetails.customer_addr[1].cus_addr_line_1 }} {{ CustomerDetails.customer_addr[1].cus_addr_line_2 }}
                {{ CustomerDetails.customer_addr[1].cus_city }} {{ getDetails($AppDetails.state_details,CustomerDetails.customer_addr[1].cus_state,'state_name') }}
                {{ getDetails($AppDetails.country_details,CustomerDetails.customer_addr[1].cus_country,'country_name') }} {{ CustomerDetails.customer_addr[1].cus_pincode }}
              </address>
            </div>
          </div>
        </b-collapse>
      </b-col>
    </b-row>
    <hr class="mb-0" />
    <b-row class="px-3 mt-1">
      <b-col>
        <b-tabs class="customer_view_tab">
          <b-tab title="Other Details" active class="pl-0 pt-2 pb-2 pr-2">
            <table class="w-100 customer_view_table">
              <tbody class="w-100">
                <tr class="w-100">
                  <td class="w-50 text-left text-muted">Currency Code</td>
                  <td
                    class="w-50 text-left"
                  >{{ getDetails($AppDetails.currency_details,CustomerDetails.main_detail.cus_currency,'currency_name') }}</td>
                </tr>
                <tr class="w-100" v-if=" CustomerDetails.main_detail.cus_website">
                  <td class="w-50 text-left text-muted">Website</td>
                  <td
                    class="w-50 text-left text-truncate"
                    style="max-width:150px !important"
                  >{{ CustomerDetails.main_detail.cus_website }}</td>
                </tr>
                <tr class="w-100" v-if="CustomerDetails.main_detail.cus_gst_type">
                  <td class="w-50 text-left text-muted">GST Treatment</td>
                  <td
                    class="w-50 text-left"
                  >{{ getJsonPresentValue($AppDetails.gst_type_list,'gst_type_id',CustomerDetails.main_detail.cus_gst_type,'gst_type_name') }}</td>
                </tr>
                <tr class="w-100" v-if="CustomerDetails.main_detail.cus_gst_no">
                  <td class="w-50 text-left text-muted">GST No</td>
                  <td class="w-50 text-left">{{ CustomerDetails.main_detail.cus_gst_no }}</td>
                </tr>
                <tr class="w-100" v-if="CustomerDetails.main_detail.cus_pan_no">
                  <td class="w-50 text-left text-muted">Pan No</td>
                  <td class="w-50 text-left">{{ CustomerDetails.main_detail.cus_pan_no }}</td>
                </tr>
                <tr class="w-100">
                  <td class="w-50 text-left text-muted">Place of Supply</td>
                  <td
                    class="w-50 text-left"
                  >{{ getDetails($AppDetails.state_details,CustomerDetails.main_detail.place_of_supply,'state_name') }}</td>
                </tr>
                <tr
                  class="w-100"
                  v-if="CustomerDetails.main_detail.cus_tax_exempt&&CustomerDetails.main_detail.cus_gst_type!=6"
                >
                  <td class="w-50 text-left text-muted">Tax Preference</td>
                  <td class="w-50 text-left">{{ CustomerDetails.main_detail.cus_tax_exempt }}</td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab title="Contacts" class="pl-1 pt-2 pb-2 pr-2">
            <template v-for="item in CustomerDetails.cus_cntct">
              <div class="media mt-2" :key="item.id">
                <div class="media-left">
                  <i class="icon-lg icon-fw la la-user la-lg mr-2"></i>
                </div>
                <div class="media-body">
                  <address class="mar-no text-dark w-100">
                    <span
                      class="d-block text-truncate"
                    >{{item.cntct_fname }} {{ item.cntct_lname}} | {{ item.cntct_role }}</span>
                    <span class="text-muted ext-truncate d-block">{{ item.cntct_mail }}</span>
                    <span class="text-muted d-block text-truncate">{{ item.cntct_no }}</span>
                  </address>
                </div>
              </div>
              <hr class="mt-1 mb-1" :key="item.id" />
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex"; // get data set in the state in vuex
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
export default {
  data() {
    return {
      customer_details: 0,
      show_customer_details: false
    };
  },
  methods: {
    toggleCustomerDetails() {
      this.show_customer_details = !this.show_customer_details;
    }
  },
  mounted() {
    EventBus.$on("toggleCustomerDetails", this.toggleCustomerDetails); // to trigger the method from parentcomponent
  },
  computed: {
    ...mapState({
      CustomerDetails: state => state.customer.listView,
      status_code: state => state.customer.status_code,
      status_message: state => state.customer.status_message,
      status_type: state => state.customer.status_type

    })
  }
};
</script>